"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconLightiningStroke = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconLightiningStroke = function SvgIconLightiningStroke(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31.25a.523.523 0 00-.467.289L2.055 6.115 4.843.539A.523.523 0 015.311.25h3.136-3.136zm2.24 3.485h2.64-2.64zm-3.107 7.428a.53.53 0 01.008-.045l.91-4.247-.91 4.247a.526.526 0 00-.008.045zM2.523 7.02h2.652l-.87 4.065a.673.673 0 001.195.545l5.227-6.97a.673.673 0 00-.538-1.076H7.793l1.256-2.511A.673.673 0 008.447.1H5.311a.673.673 0 00-.602.372L1.92 6.048a.673.673 0 00.602.973zM5.972 9.01l3.172-4.23-3.172 4.23zm.212-4.795a.522.522 0 01.053-.191l1.364-2.729-1.364 2.729a.522.522 0 00-.053.191zm.337 2.037a.523.523 0 00-.513-.426m.513.426a.522.522 0 00-.513-.426m-.054 0H3.369m3.296.663a.673.673 0 00-.657-.813H3.61l2.115-4.23H7.36l-1.256 2.51a.673.673 0 00.602.974h2.139L6.262 8.373l.403-1.884z",
    fill: "currentColor"
  }));
};

exports.SvgIconLightiningStroke = SvgIconLightiningStroke;